import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { selectDisplayMode } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { Prefab } from '@ff-resource-plugins/prefabs-shared/Prefab';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { PrefabColumnPreset, PrefabPreviewMode } from '@ff-scene-plugins/gift-shared/GiftSceneOptions';
import { selectActivePrefab, selectFilteredPrefabs } from '../../_redux-prefabs';
import { selectPrefabColumnWidths, selectPrefabPreviewMode } from '../../_redux-scene';
import { PrefabPickerGridItem } from './PrefabPickerGridItem';
import styles from './PrefabPickerGrid.module.scss';

const _PrefabPickerGrid = ({
    prefabs, mode, gridTemplateColumns
}: Props) => (
    <div className={styles.container} style={{ gridTemplateColumns }}>
        {prefabs.map(p => <PrefabPickerGridItem prefab={p} mode={mode} key={p.id} />)}
    </div>
);

type Props = OwnProps & {
    prefabs: Prefab[];
    mode: PrefabPreviewMode;
    gridTemplateColumns: string;
};

type OwnProps = {
    isMobile: boolean;
};

const mapStateToProps = (state: GiftPdpState, ownProps: OwnProps) => ({
    mode: selectPrefabPreviewMode(state),
    gridTemplateColumns: selectGridTemplateColumns(state, ownProps.isMobile),
    activePrefab: selectActivePrefab(state),
    prefabs: selectFilteredPrefabs(state)
});

export const PrefabPickerGrid = connect(
    mapStateToProps
)(_PrefabPickerGrid);

const presets: Record<PrefabColumnPreset, string> = {
    '1/4': 'repeat(4, 1fr)',
    '1/3': 'repeat(3, 1fr)',
    '1/2': 'repeat(2, 1fr)',
    'full': '1fr'
};

const selectGridTemplateColumns = createSelector([
    (state: GiftPdpState) => selectPrefabColumnWidths(state),
    (state: GiftPdpState) => selectDisplayMode(state),
    (state: GiftPdpState, isMobile: boolean) => isMobile
], (prefabColumnWidths, displayMode, isMobile) => {
    const preset = prefabColumnWidths[isMobile ? 'mobile' : displayMode] ?? '1/3';
    if (typeof preset === 'string') {
        return presets[preset];
    } else {
        return `repeat(auto-fill, minmax(${preset}px, 1fr))`;
    }
});